module.exports = __webpack_public_path__ + "img/icon4.a088f92c.svg";